export const IS_ADD_AGENT_LOADING = "IS_ADD_AGENT_LOADING";
export const ADD_AGENT_SUCCESS = "ADD_AGENT_SUCCESS";
export const ADD_AGENT_FAILED = "ADD_AGENT_FAILED";
export const IS_AGENT_DATA_LOADING = "IS_AGENT_DATA_LOADING";
export const AGENT_DATA_SUCCESS = "AGENT_DATA_SUCCESS";
export const AGENT_DATA_FAILED = "AGENT_DATA_FAILED";